// extracted by mini-css-extract-plugin
export default {"container":"sub_header-module__container--2b-B1"};